import { useCallback } from "react";
import { useNavigate } from "react-router";

import useCanManageApiKeys from "shared/ApiKey/access/useCanManageApiKeys";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTypedContext from "hooks/useTypedContext";

import { ApiKeyGroupMappingStatus, CellComponentProps } from "../types";
import { SettingsContext } from "../../../Context";
import { UserManagementActivationStatus } from "../../../types";
import { showDeleteGroupConfirmation } from "../DeleteGroupConfirmation";

type ApiKeyGroupMappingListItemDropdownActionsCellProps = CellComponentProps;

const ApiKeyGroupMappingListItemDropdownActionsCell = ({
  group,
  apiKey,
}: ApiKeyGroupMappingListItemDropdownActionsCellProps) => {
  const navigate = useNavigate();
  const canManageApiKeys = useCanManageApiKeys();
  const { activationStatus } = useTypedContext(SettingsContext);

  const canViewRoles =
    activationStatus === UserManagementActivationStatus.ACTIVE &&
    group.status === ApiKeyGroupMappingStatus.MAPPED;

  const handleViewRoles = useCallback(() => {
    if (canViewRoles) {
      navigate(`/settings/idp-group/${group.id}`);
    }
  }, [navigate, group.id, canViewRoles]);

  const handleDeleteGroup = useCallback(() => {
    showDeleteGroupConfirmation({
      groupName: group.groupName,
      apiKey,
    });
  }, [group.groupName, apiKey]);

  if (!canViewRoles && !canManageApiKeys) {
    return null;
  }

  return (
    <DropdownMenuEllipsis tooltip="Group actions">
      {canViewRoles && <DropdownMenuItem onAction={handleViewRoles}>View roles</DropdownMenuItem>}
      {canManageApiKeys && (
        <DropdownMenuItem onAction={handleDeleteGroup} danger>
          Delete
        </DropdownMenuItem>
      )}
    </DropdownMenuEllipsis>
  );
};

export default ApiKeyGroupMappingListItemDropdownActionsCell;
